<h2 class="step-title" >What is your name?</h2>
<h3 *ngIf="experiment" style="margin: -1.375rem 0 1.375rem 0;">Personal Information is Safe & Secure.</h3>
<p class="step-subtitle" *ngIf="notDebtSettlement">Get rates with no credit check required!</p>
<div class="field">
	<div class="control">
		<input *ngIf = "!inputModeTest" class="input is-large" type="text" placeholder="First Name" formControlName="firstName"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		#firstName (change)="snap()" name="firstName" >
		<input *ngIf = "inputModeTest" inputmode="text" class="input is-large" type="text" placeholder="First Name" formControlName="firstName"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		#firstName (change)="snap()" name="firstName" >
	</div>

	<div *ngIf="controls[0].touched && controls[0].errors" class="help is-danger has-text-left">
		<p *ngIf="controls[0].errors.required">First Name is required.</p>
		<p *ngIf="controls[0].errors.pattern">Invalid characters in First Name.</p>
		<p *ngIf="controls[0].errors.minlength">First Name must be at least {{controls[0].errors.minlength.requiredLength}} characters.</p>
	</div>
</div>

<div class="field">
	<div class="control">
		<input *ngIf = "!inputModeTest" class="input is-large" type="text" placeholder="Last Name" formControlName="lastName"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
		#lastName (change)="snap()" name="lastName">
		<input *ngIf = "inputModeTest" inputmode="text" class="input is-large" type="text" placeholder="Last Name" formControlName="lastName"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
		#lastName (change)="snap()" name="lastName">
	</div>

	<div *ngIf="controls[1].touched && controls[1].errors" class="help is-danger has-text-left">
	  <p *ngIf="controls[1].errors.required">Last Name is required.</p>
	  <p *ngIf="controls[1].errors.pattern">Invalid characters in Last Name.</p>
	  <p *ngIf="controls[1].errors.minlength">Last Name must be at least {{controls[1].errors.minlength.requiredLength}} characters.</p>
	</div>
</div>


<button class="button continue is-large has-shadow-small" (click)="submit()">
	Continue
	<i class="fas fa-chevron-right"></i>
</button>